import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBergischGladbach() {
  return (
    <CityPageTemplate
      city="Bergisch Gladbach"
      slug="bergisch-gladbach"
      intro="Bergisch Gladbach als Teil der Metropolregion Köln – smarte Finanzberatung für das Bergische Land."
      description="Unabhängige & digitale Finanzberatung für Bergisch Gladbach: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
